import React, { useRef, useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import loader from '../../../assets/img/loader.svg';
import Api from '../../../_helpers/Api';
import { useMessagesContext } from '../../../_providers/Messages';
import { trans, plural } from '../../../_providers/Translation';

let timeout;

function Employees(props) {

    const messages = useMessagesContext();

    const ref = useRef(null);

    const [state, setState] = useState({
        loading: true,
        list: [],
        search: '',
        update: false,
        key: Math.random().toString(),
        initLoad: true
    });

    useEffect(() => {
        loadData();
    }, [state.update]);

    useEffect(() => {
        if (!state.initLoad) {
            handleUpdate();
        }
    }, []);

    const loadData = (page = 1) => {
        let empUrl = 'partners/employees/all?active=1&sort=name&except_current_user=1';
        let adminUrl = 'partners/employees/partner-admins';

        if (state.search) {
            empUrl += '&name=' + state.search;
            adminUrl += '?name=' + state.search;
        }

        Promise.all([
            Api.get(empUrl),
            Api.get(adminUrl)
        ]).then(([empRes, adminRes]) => {
            const employees = empRes.data || [];
            const admins = (adminRes.data || []).map(a => ({ ...a, isAdmin: true }));
            // Employees first, then admins
            const merged = [...employees, ...admins];
            setState(prev => ({
                ...prev,
                list: merged,
                loading: false,
                initLoad: false
            }));
        });
    }

    const handleSearch = e => {
        let val = e.target.value;

        clearTimeout(timeout);

        timeout = setTimeout(() => {
            setState(prev => ({
                ...prev,
                search: val,
            }));

            handleUpdate();

        }, 500);
    }

    const handleUpdate = () => {
        setState(prev => ({
            ...prev,
            list: [],
            loading: true,
            update: new Date().getTime(),
            key: Math.random().toString()
        }));
    }

    const handleOpenChat = (user) => {
        // Pass tenant_id as receiver_tenant_id for consistency with MessagePanel
        messages.openChat({
            id: user.id,
            type: user.type,
            name: user.name,
            lastname: user.lastname,
            avatar: user.avatar,
            tenant_id: user.tenant_id,
            receiver_tenant_id: user.tenant_id // ensure receiver_tenant_id is set
        });
    }

    return (
        <div className={`show messages-module`}>
            <div className="head">
                {trans('header.employees')}
            </div>
            <div className="body">
                <div className="scroll" ref={ref} key={state.key}>
                    {state.loading
                        ?
                        <img src={loader} alt="loading" />
                        :
                        state.list.length === 0
                            ?
                            <p className="no-data">{trans('messages.noEmployees')}</p>
                            :
                            <ul>
                                {state.list.map(el =>
                                    <li key={(el.isAdmin ? 'a-' : 'e-') + el.id} onClick={() => handleOpenChat(el)}>
                                        <picture>
                                            <img src={el.avatar} alt="avatar" />
                                        </picture>
                                        <div className="right">
                                            <h3>
                                                {el.name} {el.lastname}
                                                {el.isAdmin && <span style={{marginLeft:8, color:'#1976d2', fontSize:'0.8em', fontWeight:600}}>[{trans('labels.partner')}]</span>}
                                            </h3>
                                            {el.isAdmin && el.partner_name && (
                                                <span style={{fontSize:'0.9em', color:'#888', fontWeight:400, marginTop:2}}>{el.partner_name}</span>
                                            )}
                                        </div>
                                    </li>
                                )}
                            </ul>
                    }
                </div>
                <input
                    type="search"
                    placeholder={trans('filters.search')}
                    onChange={handleSearch}
                />
            </div>
        </div>
    )
}

export default Employees;